import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import {
  CircularProgress,
  FormLabel,
  Grid,
  IconButton,
  TextField,
} from "@material-ui/core";
import Typography from "@components/Typography";
// import TextField from "@components/TextField";
import Button from "@components/Button";
import userApi from "@api/user";
import NativeSelectComponent from "@components/NativeSelectComponent";
import { ColProps_3 } from "@core/utils/ColProps";
import SelectCurrency from "@components/SelectCurrency";
import { CURRENCY } from "@core/utils/consts";
import { useParams } from "react-router-dom";
import NumberFormat from "react-number-format";
import { notification } from "@core/helper/notificationHelper";

function NumberFormatCustom(props) {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
}

export default function AlertModal(props) {
  const classes = useStyles();
  const { handleClose, open, overrideDefaultValue } = props;
  const [loading, setLoading] = useState(false);

  const currencyName = useParams()?.currencyName?.split("-")[0];
  const [defaultValue, setDefaultValue] = useState(
    CURRENCY?.TYPE[currencyName]?.UNIT ?? CURRENCY?.TYPE["BTC"]?.UNIT
  );
  const [values, setValues] = useState({ market: "1", currency: defaultValue });
  useEffect(() => {
    if (currencyName) {
      setDefaultValue(CURRENCY?.TYPE[currencyName]?.UNIT);
    }
  }, [currencyName]);

  const onSubmit = () => {
    setLoading(true);
    userApi
      .addAlert({
        payload: {
          crossType: values.onCondition === "1" ? "UP" : "DOWN",
          marketName:
            values.market === "1"
              ? values.currency + "_IRT"
              : values.currency + "_USDT",
          price: eval(values.price),
        },
      })
      .then((data) => {
        setLoading(false);
        notification("", "success", data?.message);
        resetForm();
        handleClose();
      })
      .catch((data) => {
        setLoading(false);
        notification(
          "",
          "danger",
          !!data && !!data?.message ? data?.message : "SERVER ERROR"
        );
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const resetForm = () => {
    setValues({ market: "1", currency: defaultValue });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth="true"
      maxWidth="sm"
      className={classes.dialogRoot}
    >
      <DialogTitle>
        <Typography color="secondary.main" variant="lg" isBold>
          {__t("Set alert")}
        </Typography>
        <IconButton className={classes.closeButton} onClick={handleClose}>
          <span className="icon-x" />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Grid container direction="column" spacing={10}>
          <Grid item>
            <Typography color="secondary.tint40">
              {__t(
                "If there is a problem, you can report your problem to the relevant department"
              )}
            </Typography>
          </Grid>

          <Grid item>
            <FormLabel className={classes.formLabel}>
              {__t("Select Currency")}
            </FormLabel>
            <SelectCurrency
              handleChange={handleInputChange}
              name="currency"
              defaultValue={!!overrideDefaultValue ? "" : defaultValue}
              placeholder={__t("Select")}
            />
          </Grid>

          <Grid item>
            <FormLabel className={classes.formLabel}>
              {__t("Activation condition")}
            </FormLabel>
            <NativeSelectComponent
              name="onCondition"
              options={[
                { id: 1, name: __t("Rising prices of") },
                { id: 2, name: __t("Going down prices from") },
              ]}
              placeholder={__t("Select")}
              onChange={handleInputChange}
              value={values.onCondition}
            />
          </Grid>

          <Grid item>
            <FormLabel className={classes.formLabel}>{__t("Price")}</FormLabel>
            <TextField
              className={classes.customTextfield}
              variant="outlined"
              name="price"
              onChange={handleInputChange}
              value={values.price}
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <NativeSelectComponent
                    className={classes.formControlOverride}
                    name="market"
                    options={
                      values.currency === "USDT"
                        ? [{ id: 1, name: __t("toman") }]
                        : [
                            { id: 1, name: __t("toman") },
                            { id: 2, name: __t("tether") },
                          ]
                    }
                    onChange={handleInputChange}
                    value={values.market}
                    disabled={values.currency === "USDT" ? true : false}
                  />
                ),
              }}
            />
          </Grid>
          <Grid
            container
            item
            direction="row-reverse"
            className={classes.actionContainer}
            spacing={10}
          >
            <Grid item {...ColProps_3}>
              <Button
                color="primary"
                isBold
                fullWidth
                disabled={
                  !!values.currency && !!values.price && !!values.onCondition
                    ? false
                    : true
                }
                onClick={onSubmit}
              >
                {loading ? (
                  <CircularProgress className={classes.loading} />
                ) : (
                  ""
                )}
                <Typography>{__t("Save")}</Typography>
              </Button>
            </Grid>
            <Button color="default" isBold onClick={handleClose}>
              <Typography>{__t("Exit")}</Typography>
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
